<ng-container *ngIf="searchResults$ | async as searchResults">
    <h1 class="title" [innerHTML]="searchResults.breadcrumbs[0]?.facetValueName ? searchResults.breadcrumbs[0].facetValueName : '&nbsp;'">
        &nbsp;
    </h1>
    <p class="description" *ngIf="searchResults.categoryDescription" [innerHTML]="searchResults.categoryDescription">
    </p>
    <cx-media *ngIf="searchResults.image" class="image" [container]="searchResults.image" />
</ng-container>
